import Vue from 'vue';
export const EventBus: Vue = new Vue();
